import { Button } from "components/ui/button";
import Layout from "layout/layout";
import SettingContentLayout from "layout/setting-content/SettingContentLayout";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { DropdownMenu, DropdownMenuContent, DropdownMenuGroup, DropdownMenuItem, DropdownMenuTrigger } from "components/ui/dropdown-menu";
import { useAppSelector } from "store/store";
import { setLanguage } from "store/settingSlice";
import { useDispatch } from "react-redux";

export default function Language() {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState<boolean>(false);
  const { t, i18n } = useTranslation();
  const { lang } = useAppSelector((state) => state.setting);

  const changeLanguage = (lng: string) => {
    dispatch(setLanguage(lng));
    i18n.changeLanguage(lng);
    localStorage.setItem("lang", lng);
  };

  useEffect(() => {
    if (lang) {
      i18n.changeLanguage(lang);
      dispatch(setLanguage(lang));
    }
  }, [i18n, lang, dispatch]);

  return (
    <SettingContentLayout>
      {!loading && (
        <div className="p-4">
          <div className="flex items-center">
            <div>
              <h1 className="text-lg font-semibold">{t("Language")}</h1>
              <p className="text-muted-foreground text-sm">View and manage the devices currently signed into your account for better security and control.</p>
            </div>
          </div>
          <div>
            <DropdownMenu>
              <DropdownMenuTrigger className="w-full mt-2" asChild>
                <Button variant="outline">{lang === "en" ? `${t("English")}` : `${t("Khmer")}`}</Button>
              </DropdownMenuTrigger>
              <DropdownMenuContent className="w-full">
                <DropdownMenuGroup>
                  <DropdownMenuItem onClick={() => changeLanguage("en")}>
                    <span>{t("English")}</span>
                  </DropdownMenuItem>
                  <DropdownMenuItem onClick={() => changeLanguage("km")}>
                    <span>{t("Khmer")}</span>
                  </DropdownMenuItem>
                </DropdownMenuGroup>
              </DropdownMenuContent>
            </DropdownMenu>
          </div>
        </div>
      )}
    </SettingContentLayout>
  );
}
